module.exports = __webpack_public_path__ + "img/resident-logs.fb64a2bc.png";